export default __webpack_public_path__ + "static/media/kitchen4-afterF-1024w.2efce587.webp";